<template>
  <b-tabs
    class="contract-tabs"
    v-model="activeTab"
    @change="loadTabById"
    ref="tabs"
  >
    <!-- <b-tab-item label="Rates" id="tab-rates"> -->
      <!-- <code-table
        :firm-id="firmId"
        :contract-id="contract.id"
        type="rate"
        v-if="isTabLoaded('tab-rates')"
      /> -->
      <!-- <rate-table
        :firm-id="contract.contractor_firm_id"
        :contract-id="contract.id"
        v-if="isTabLoaded('tab-rates')"
      />
    </b-tab-item> -->
    <b-tab-item label="Rates" id="tab-rates-new">
      <rate-table-new
        :firm="firm"
        :contract="contract"
        v-if="isTabLoaded('tab-rates-new')"
      />
    </b-tab-item>
    <b-tab-item label="Rates Config" id="tab-rates-config">
      <rate-code-matrix-manager
        :contract="contract"
        v-if="isTabLoaded('tab-rates-config')"
      />
    </b-tab-item>
    <b-tab-item label="Codes" id="tab-codes">
      <!-- <code-table
        :firm-id="firmId"
        :contract-id="contract.id"
        :types="['orderPriority']"
        v-if="isTabLoaded('tab-codes')"
      /> -->
      <code-table
        :firm-id="firm.id"
        :contract-id="contract.id"
        v-if="isTabLoaded('tab-codes')"
      />
    </b-tab-item>
    <b-tab-item label="Codes Config" id="tab-codes-config">
      <code-matrix-manager
        :contract-id="contract.id"
        v-if="isTabLoaded('tab-codes-config')"
      />
    </b-tab-item>
    <b-tab-item label="Service Levels" id="tab-service-levels">
      <service-level-table
        :contract-id="contract.id"
        :organization="firm"
        v-if="isTabLoaded('tab-service-levels')"
      />
    </b-tab-item>
    <b-tab-item label="Assets" id="tab-assets">
      <asset-contract-copy-tool :contract="contract" v-if="isTabLoaded('tab-assets')" />
    </b-tab-item>
  </b-tabs>
</template>

<script>
import AssetContractCopyTool from "@/components/Asset/AssetContractCopyTool";
import CodeTable from "@/components/Code/CodeTable";
import CodeMatrixManager from "@/components/pages/CodesMatrixManager/index";
import RateCodeMatrixManager from "@/components/MatrixManager/RateCodeMatrixManager";
import RateTable from "@/components/Rate/RateTable";
import RateTableNew from "@/components/Rate/RateTableNew";
import ServiceLevelTable from "@/components/pages/ServiceLevels/list";
import { tabsMixin } from "@/mixins/tabsMixin";

export default {
  props: {
    firm: {
      type: Object,
    },
    contract: {
      type: Object,
      required: true,
    },
    firmId: {
      type: [String, Number],
    },
  },
  mixins: [tabsMixin],
  components: {
    AssetContractCopyTool,
    CodeTable,
    CodeMatrixManager,
    RateCodeMatrixManager,
    RateTable,
    RateTableNew,
    ServiceLevelTable,
  },
  data: () => ({
    activeTab: 0,
  }),
  mounted() {
    // Load initial tab
    this.loadTabById(0);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Contracts/partials/tabs.vue